'use strict';

import $ from 'jquery';
import mCustomScrollbar from 'malihu-custom-scrollbar-plugin';

export default class StandardContent {
  constructor() {
    $('.rte table').wrap('<div class="table"></div>');
    mCustomScrollbar($);
    $(window).on("load",function(){
      $(".table").mCustomScrollbar({
        axis:"x", // horizontal scrollbar
        contentTouchScroll: true,
        documentTouchScroll: true,
        autoHideScrollbar: true
      });
    });

    //  ajax call on success page to send the transaction details to backend
    if($('#UpdateTransaction').length) {
      let successNotificationUrl = $('#UpdateTransaction').data('notificationUrl'),
          successNotificationMsg = $('#UpdateTransaction').data('notificationMessage');
      $.ajax({
        url: successNotificationUrl,
        method: 'POST',
        data: { message: successNotificationMsg}
      });
    }
  }
}
